import { RefreshCcw } from "lucide-react";
import React from "react";

import { IgButton, IgDialog, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useDialog, useDialogs } from "@src/hooks/dialog";
import { useSelector } from "@src/store";

export const UpdateDetectedDialog = () => {
  const dialog = useDialog("updatedDetected");
  const { closeDialog } = useDialogs();

  const theme = useTheme();
  const shouldIgnore = useSelector(
    (state) => state.global.ignoreUpdateDetected
  );

  if (shouldIgnore) {
    return null;
  }

  return (
    <IgDialog
      handleClose={(reason) => {
        if (reason === "button") {
          closeDialog("setDomain");
        }
      }}
      rawContent={
        <Grid container direction={"column"} rowSpacing={2}>
          <Grid>
            <IgTypography>
              Updates have been made. Refresh <br /> the page to view the latest
              data.
            </IgTypography>
          </Grid>
          <Grid>
            <IgButton
              startIcon={<RefreshCcw color={theme.igIconColors.dark} />}
              onClick={() => window.location.reload()}
              variant={"contained"}
            >
              Refresh Now
            </IgButton>
          </Grid>
        </Grid>
      }
      title={"Updates Detected"}
      showDialog={dialog.isOpen}
      hideActions={true}
      shouldNotClose={true}
      dialogHeight={null}
    />
  );
};
